import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactDOM from "react-dom";
import { IoIosClose } from "react-icons/io";
import { makeStyles } from "@material-ui/core/styles";

import { hidePopup } from "components/ConfirmPopup/popupSlice";
import { logOut } from "features/Login/loginSlice";
import { deleteNews } from "features/News/newsSlice";
import {deletePodcast} from "features/Podcast/podcastSlice"


const useStyles = makeStyles(() => ({
  modalContainer: {
    height: "100vh",
    width: "100vw",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 9999,
    backgroundColor: "rgba(0, 0, 0, .8)",
  },

  modal: {
    position: "absolute",
    left: "50%",
    top: "35%",
    transform: "translate(-50%, -50%)",
    zIndex: 99,
    minWidth: "320px",
    backgroundColor: "#fff",
    padding: "2rem",
    borderRadius: "15px",
  },

  close: {
    display: "block",
    marginLeft: "auto",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    color: "#9d9d9d",
    position: "absolute",
    right: "0",
    top: "0",

    "& > svg": {
      fontSize: "3rem",
    },
  },

  form: {
    maxHeight: "88vh",
    overflow: "auto",
    backgroundColor: "#fff",
    padding: "1rem 1rem 0 1rem",
  },

  btnContainer: {
    width: "100%",
    marginTop: "2rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  btn: {
    width: "100%",
    backgroundColor: "transparent",
    border: "none",
    textAlign: "center",
    padding: "1rem",
  },
  text: {
    textAlign: "center",
  },
  backBtn: {
    width: "max-content",
    minWidth: "100px",
    padding: "5px 10px",
    border: "none",
    outline: "none",
    background: '#c6c6c6',
    fontFamily: 'sans-serif !important',
    transition: 'background 0.3s ease',
    '&:hover': {
      background: '#858685',
      color: 'white',
    },
  },
  buttonSubmit: {
    width: "max-content",
    minWidth: "100px",
    padding: "5px 10px",
    border: "none",
    outline: "none",
    marginBottom: "20px",
    marginTop: "20px",
    background: '#45b77c',
    fontFamily: 'sans-serif !important',
    transition: 'background 0.3s ease',
    '&:hover': {
      background: '#358c5e',
      color: 'white',
    },
  },
}));

const Modal = ({ parent }) => {
  const dispatch = useDispatch();
  const styles = useStyles();

  const id = useSelector((state) => state.popup.id);


  function onDismiss() {
    dispatch(hidePopup());
  }

  function handleYes() {
    switch (parent) {
      case "news":
        dispatch(deleteNews([id]));
        break;
      case "podcast":
        dispatch(deletePodcast([id]));
        break;
      case "topbar":
        dispatch(logOut());
        break;
      default:
        break;
    }
    onDismiss();
  }

  return ReactDOM.createPortal(
    <div onClick={onDismiss} className={styles.modalContainer}>
      <div onClick={(e) => e.stopPropagation()} className={styles.modal}>
        <button onClick={onDismiss} className={styles.close}>
          <IoIosClose />
        </button>

        <div className={styles.form}>
          <p className={styles.text}>
            {parent === "topbar"
              ? "Are you sure you want to logout"
              : "Are you sure you want to delete the Item?"}
          </p>
          <div className={styles.btnContainer}>
            <button onClick={onDismiss} className={styles.backBtn}>
              No
            </button>
            <button onClick={handleYes} className={styles.buttonSubmit}>
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.querySelector("#popup")
  );
};

export default Modal;
